<template>
    <section class="advantages" id="elonyok">
        <div class="container">
          <h1>Cégadatok lekérése <b>egyszerűen</b></h1>
          <p class="text-center">A Cégjelző Messenger Céginfó egy céginformációs chatbot szolgáltatás, amely sokkal gyorsabbá és egyszerűbbé teszi a cégadatok lekérdezését.</p>
          <div class="row responsive-row">
            <base-card-hover
              class="col col-md-2 col-sm-6 col-xs-12"
              iconClass="far fa-chart-bar"
              title="Árbevétel"
            />

            <base-card-hover
              class="col col-md-2 col-sm-6 col-xs-12"
              iconClass="fas fa-user-friends"
              title="Létszám"
            />

            <base-card-hover
              class="col col-md-2 col-sm-6 col-xs-12"
              iconClass="fas fa-question"
              title="Van-e a cég ellen eljárás"
            />

            <base-card-hover
              class="col col-md-2 col-sm-6 col-xs-12"
              iconClass="far fa-address-card"
              title="Ügyvezető"
            />

            <base-card-hover
              class="col col-md-2 col-sm-6 col-xs-12"
              iconClass="fas fa-chess-rook"
              title="Tulajdonos"
            />
          </div>
        </div>
    </section>
</template>

<script>
import BaseCardHover from '@/components/base/BaseCardHover'

export default {
  name: "Advantages",
  data() {
    return {
    };
  },
  components: {
    BaseCardHover
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.advantages {
  background: white;
  min-height: 200px;
  color: var(--color-grey-2);
}

.btn-try {
  text-align: center;
  margin-top: 32px;
}

.btn-try a {
  margin-left: auto;
  margin-right: auto;
}

h1 {
  margin-bottom: 32px;
}
</style>
